import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  private readonly spinner = inject(NgxSpinnerService);
  private _activeRequest = 0;

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const action = request.headers.get('frontend-action');

    if (this._activeRequest === 0 && action !== 'silence') {
      this.spinner.show();
    }

    if (action !== 'silence') this._activeRequest++;

    return next.handle(request).pipe(
      finalize(() => {
        this._stopLoader(action);
      })
    );
  }

  private _stopLoader(action: string | null) {
    if (action !== 'silence') this._activeRequest--;
    if (this._activeRequest === 0) {
      this.spinner.hide();
    }
  }
}
